import { GetConstraintsResponse } from 'api/typegen/application/constraints/get';
import fetchWebApi from 'api/fetchWebApi';

const getApplicationConstraintsApiCall =
  async (): Promise<GetConstraintsResponse> =>
    fetchWebApi('/application/constraints');

export default getApplicationConstraintsApiCall;
